import {OrderContext} from "../../context/OrderContext";
import React, {useContext} from "react";
import OrderMessaging from "./orderMessaging";

export default function OrderContactPerson() {
    const {order} = useContext(OrderContext);

    return (
        <div className={"border border-gray-500 rounded-lg bg-white  divide-y divide-gray-300 overflow-hidden text-left mb-2 sm:mb-4 md:mb-8"}>
            <div className={'lg:p-6  p-4'}>
                <div className="px-4 sm:px-0 mb-4">
                    <h3 className="text-base/7 font-semibold text-gray-900">Benachrichtigungen</h3>
                </div>
                <div className={ "lg:-mx-6 -mx-4 pr-2"}>
                    <OrderMessaging data={{"title":"", "linkType": "orderDirectMessage", "linkId": order?.id, "orderId":order?.id ,"type": "all", "stage": order?.stage}}/>
                </div>
            </div>
        </div>
    );

}